/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";
import { ROUTES, useMediaQueries } from "@/shared";
import DialogActions from "@/shared/components/buttons/DialogActions";

interface ConfirmDeactivateResourceProps {
  isOpen: boolean;
  route: ROUTES;
  resourceName: string;
  onClose: () => void;
  onSubmit: () => void;
}

const ConfirmDeactivateResource = ({
  isOpen,
  route,
  resourceName,
  onClose,
  onSubmit
}: ConfirmDeactivateResourceProps) => {
  const { t } = useTranslation();
  const { toMd } = useMediaQueries();

  const getTitleAndDescription = () => {
    switch (route) {
      case ROUTES.Integrations:
        return {
          title: t("Dialog##confirm deactivate integration##title"),
          description: t(
            "Dialog##confirm deactivate integration##description",
            {
              integrationName: resourceName
            }
          )
        };

      case ROUTES.IntegrationsApi:
        return {
          title: t("Dialog##confirm deactivate api key##title"),
          description: t(`Dialog##confirm deactivate api key##description`, {
            apiKeyName: resourceName
          })
        };

      default:
        return {
          title: "",
          description: ""
        };
    }
  };

  const { title, description } = getTitleAndDescription();

  return (
    <Dialog
      title={title}
      description={description}
      extendToMaxWidth={toMd}
      open={isOpen}
      close={onClose}
      submit={onSubmit}
      width={DialogWidth.TinyWidth}
      css={css({
        "& .MuiDialog-paper": {
          minWidth: DialogWidth.TinyWidth
        }
      })}
      actions={
        <div
          css={css({
            display: "flex",
            flexDirection: "column-reverse",
            gap: "8px"
          })}
        >
          <DialogActions
            onClose={onClose}
            isLoading={false}
            isreadyToConfirm
            secondaryColor="modalWhite"
            confirmationButtonText={t("Button##confirm")}
            confirmationButtonTestId="confirm-deactivate-resource-button"
            cancelButtonText={t("Button##back")}
            cancelButtonTestId="back-confirm-deactivate-resource"
          />
        </div>
      }
    />
  );
};

export default ConfirmDeactivateResource;
